import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";

const useStyles = makeStyles((theme) => ({
  margin: {
    height: theme.spacing(3)
  },
  thumb: {
    background: "white",
    "&~&": {
      background: "white"
    }
  },
  mark: {
    background: "white"
  },
  rail: {
    background: "white"
  },
  track: {
    background: "white"
  },
  valueLabel: {
    "&>*": {
      background: "black"
    }
  }
}));

const marks = [
    {
      value: 0,
      label: '-10000',
    },
    {
      value: 25,
      label: '10000-15000',
    },
    {
      value: 50,
      label: '15000-20000',
    },
    {
      value: 75,
      label: '20000-25000',
    },
    {
        value: 100,
        label: '20000-25000',
      }
  ];

export default function DiscreteSlider() {
  const classes = useStyles();


  return (
    <div>
      <Slider
        classes={{
          thumb: classes.thumb,
          rail: classes.rail,
          track: classes.track,
          valueLabel: classes.valueLabel,
          mark: classes.mark
        }}
        valueLabelDisplay="auto"
        step={25}
        marks={marks}
        min={0}
        max={100}
      />
    </div>
  );
}
